(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cafe-trade-supply"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-me-cafe-trade]').forEach(function(section) {
    if (section.dataset.meCafeBound === 'true') return;
    section.dataset.meCafeBound = 'true';

    var wholesaleRoot = document.getElementById('meWholesale');
    var catalogue = wholesaleRoot ? wholesaleRoot.querySelector('[data-catalogue]') : null;
    if (!catalogue) return;

    var syncVisibility = function() {
      section.hidden = catalogue.hidden;
    };

    syncVisibility();

    var observer = new MutationObserver(syncVisibility);
    observer.observe(catalogue, { attributes: true, attributeFilter: ['hidden'] });
  });

  } catch(e) { console.error(e); }
})();
})();
